import Vue from 'vue'

export default {
  install: function (Vue) {
    Vue.mixin({
      methods: {
        isBrowser (name) {
          switch (name) {
            case 'Chrome' : {
              return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
            }
            case 'ChromeIOS' : {
              return !!navigator.userAgent.match('CriOS')
            }
            case 'Firefox' : {
              return typeof InstallTrigger !== 'undefined';
            }
            case 'Opera' : {
              return !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
            }
            case 'Edge' : {
              // Internet Explorer 6-11
              let isIE = /*@cc_on!@*/false || !!document.documentMode;

              // Edge 20+
              return !isIE && !!window.StyleMedia;
            }
            case 'IE' : {
              return /*@cc_on!@*/false || !!document.documentMode;
            }
            default : {
              // console.log('!!!BROWSER ', name, ' IS NOT IN BROWSERS LIST!!!')
              return false
            }
          }
        },
      },
    })
  },
}
